import React, { useState } from 'react';
import '../App.css';
import IncidentForm from '../components/IncidentForm';
import ResultsDisplay from '../components/ResultsDisplay';

const IncidentPage = ({ apiUrl, setApiUrl, idToken }) => {
  const [analysisResult, setAnalysisResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [connectionStatus, setConnectionStatus] = useState(null);

  const testConnection = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${apiUrl}/api/test-ai`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
      });
      const data = await response.json();
      setConnectionStatus(data);
    } catch (err) {
      setConnectionStatus({
        success: false,
        message: `Failed to connect to ${apiUrl}`
      });
    } finally {
      setLoading(false);
    }
  };

  const testWithSampleData = () => {
    const sampleData = {
      id: "TEST-001",
      summary: "This is a test summary to verify UI binding is working.",
      timeline: [
        { time: "2024-01-26T10:00:00Z", event: "Test event 1" },
        { time: "2024-01-26T10:05:00Z", event: "Test event 2" }
      ],
      rootCause: "Test root cause",
      impact: "Test impact",
      resolution: "Test resolution",
      recommendations: [
        { description: "Test recommendation 1" },
        { description: "Test recommendation 2" }
      ],
      narrative: "Test narrative.",
      metadata: { processingTime: "100ms", modelUsed: "test-model", hasRealAI: true },
      processedAt: new Date().toISOString()
    };
    setAnalysisResult(sampleData);
  };

  const handleAnalysisComplete = (result) => {
    let finalResult = result;
    if (result && result.success && result.data) {
      finalResult = result.data;
    } else if (result && result.data) {
      finalResult = result.data;
    }
    setAnalysisResult(finalResult);
    setError(null);
  };

  const handleError = (errorMessage) => {
    setError(errorMessage);
    setAnalysisResult(null);
  };

  const handleApiUrlChange = (e) => {
    const newUrl = e.target.value;
    setApiUrl(newUrl);
    localStorage.setItem('apiUrl', newUrl);
  };

  return (
    <>
      {/* <div className="config-section">
        <div className="api-url-input">
          <label htmlFor="apiUrl">Backend API URL:</label>
          <input
            type="text"
            id="apiUrl"
            value={apiUrl}
            onChange={handleApiUrlChange}
            placeholder="http://localhost:3000"
          />
        </div>
        <div className="status-section">
          <button onClick={testConnection} className="test-btn" disabled={loading}>
            {loading ? 'Testing...' : 'Test AI Connection'}
          </button>
          <button onClick={testWithSampleData} className="test-btn" style={{ backgroundColor: '#9c27b0' }}>
            🧪 Test UI Binding
          </button>
          {connectionStatus && (
            <div className={`connection-status ${connectionStatus.success ? 'success' : 'error'}`}>
              {connectionStatus.success ? '✅' : '❌'} {connectionStatus.message}
              {connectionStatus.response && (
                <span className="response-detail"> - Response: "{connectionStatus.response}"</span>
              )}
            </div>
          )}
        </div>
      </div> */}

      <div className="content-grid">
        <div className="form-section">
          <IncidentForm
            onAnalysisComplete={handleAnalysisComplete}
            onError={handleError}
            setLoading={setLoading}
            apiUrl={apiUrl}
            idToken={idToken}
          />
        </div>
        <div className="results-section">
          {error && (
            <div className="error-message">
              <h3>❌ Error</h3>
              <p>{error}</p>
            </div>
          )}
          {loading && <div className="loading">Analyzing incident...</div>}
          {analysisResult && <ResultsDisplay result={analysisResult} apiUrl={apiUrl} />}
          {!analysisResult && !loading && !error && (
            <div className="placeholder">
              <h3>📋 Analysis Results</h3>
              <p>Submit incident data to see AI analysis results here.</p>
              <div className="placeholder-demo">
                <p>Example outputs will include:</p>
                <ul>
                  <li>Incident summary</li>
                  <li>Timeline visualization</li>
                  <li>Root cause analysis</li>
                  <li>Recommendations</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default IncidentPage;